import { useState, useRef, useCallback, useEffect } from "react";
import Store from "./Store";
import Audio from "./Audio";
import Timer from "./Timer";
import AppRouter from "@/features/router/AppRouter";
import AppLayout from "@/components/AppLayout";
import OnboardingGuide from "@/screens/OnboardingGuide/OnboardingGuide";

import { useAnalytics } from "@/hooks/useAnalytic";
import { useDemoTracking } from "@/hooks/useDemoTracking";
import { useClickTracking } from "@/hooks/useClickTracking";
import { isDemoUser } from "@/utils/userFlags";
import { useAuth } from "@/features/auth";
import { useBootstrap } from "@/features/bootstrap";

export default function AnimatedRoutes() {
  const { user } = useAuth();
  const { data: bootstrapUser } = useBootstrap();
  const [wellnessId, setWellnessId] = useState(0);
  const [achievements, setAchievements] = useState({});
  const isDemo = isDemoUser(user);
  const idempotencyKeyRef = useRef(crypto.randomUUID());
  const onboardingUser = bootstrapUser ?? user;

  useClickTracking();
  useAnalytics();
  useDemoTracking();

  const resetIdempotencyKey = useCallback(() => {
    idempotencyKeyRef.current = crypto.randomUUID();
  }, []);

  const routeContext = {
    wellnessId,
    setWellnessId,
    wellnessIdempotencyKey: idempotencyKeyRef,
    resetIdempotencyKey,
    achievements,
    setAchievements,
  };

  return (
    <Store>
      <Audio>
        <Timer>
          <AppLayout>
            <AppRouter isDemo={isDemo} routeContext={routeContext} />
          </AppLayout>
          <OnboardingGuide user={onboardingUser} />
        </Timer>
      </Audio>
    </Store>
  );
}
